import { Component } from '@angular/core';
import {GrafanaEmbedComponent} from '../../grafana/grafana-embed';

@Component({
  selector: 'app-dashboard',
  imports: [
    GrafanaEmbedComponent
  ],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.scss',
})
export class DashboardComponent {
  grafanaUrl =
    'https://rd.vigimare.simavi.ro/grafana/d/iosl7m7/overview' +
    '?orgId=1' +
    '&kiosk' +
    '&from=now-6h' +
    '&to=now' +
    '&refresh=30s';
}
